var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 3.07129C22.1543 3.07129 27.1431 8.06012 27.1431 14.2141C27.1431 18.9223 23.8351 24.0533 17.3034 29.6631C16.5539 30.3068 15.4467 30.3068 14.6942 29.6605L14.2625 29.2863C8.01985 23.8243 4.85742 18.8174 4.85742 14.2141C4.85742 8.06012 9.84625 3.07129 16.0003 3.07129ZM16.0003 4.78557C10.793 4.78557 6.57171 9.00689 6.57171 14.2141C6.57171 18.2165 9.48416 22.8276 15.3883 27.9935L15.8141 28.3626C15.9212 28.4546 16.0794 28.4546 16.1864 28.3626C22.3762 23.0465 25.4289 18.3117 25.4289 14.2141C25.4289 9.00689 21.2075 4.78557 16.0003 4.78557ZM16.0003 9.92843C18.3672 9.92843 20.286 11.8472 20.286 14.2141C20.286 16.5811 18.3672 18.4999 16.0003 18.4999C13.6333 18.4999 11.7146 16.5811 11.7146 14.2141C11.7146 11.8472 13.6333 9.92843 16.0003 9.92843ZM16.0003 11.6427C14.5801 11.6427 13.4289 12.794 13.4289 14.2141C13.4289 15.6343 14.5801 16.7856 16.0003 16.7856C17.4204 16.7856 18.5717 15.6343 18.5717 14.2141C18.5717 12.794 17.4204 11.6427 16.0003 11.6427Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.aa635ad4d75dc607a59884efd129a233.svg";
export { ForwardRef as ReactComponent };